// // // // import React from 'react'
// // // // import Footer from '../components/Footer'
// // // // import Header from '../components/Header'

// // // // function LoginSubscription() {
// // // //   return (
// // // //     <div>
// // // //     <Header/>
// // // //     <div>

// // // //     </div>
// // // //     <Footer/>
      
// // // //     </div>
// // // //   )
// // // // }

// // // // export default LoginSubscription







// // // import React from 'react';
// // // import Footer from '../components/Footer';
// // // import Header from '../components/Header';

// // // function LoginSubscription() {
// // //   return (
// // //     <div className="min-h-screen flex flex-col">
// // //       <Header />

// // //       <div className="flex-1 bg-gray-100 py-10 px-4 mt-[8rem]">
// // //         <h2 className="text-2xl font-bold text-center mb-8">Subscription Plans</h2>

// // //         <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
// // //           {/* Registered User Card */}
// // //           <div className="bg-white rounded-xl shadow-lg p-6 border">
// // //             <h3 className="text-xl font-semibold text-gray-800 mb-4">Registered User (Email Provided)</h3>
// // //             <ul className="text-gray-700 space-y-2 list-disc list-inside">
// // //               <li><strong>Limit:</strong> 20 queries</li>
// // //               <li><strong>Access:</strong> User receives login credentials via email</li>
// // //               <li><strong>After 20 Queries:</strong> Prompt user to upgrade to a paid plan</li>
// // //             </ul>
// // //           </div>

// // //           {/* Premium User Card */}
// // //           <div className="bg-white rounded-xl shadow-lg p-6 border">
// // //             <h3 className="text-xl font-semibold text-gray-800 mb-4">Pro User (Paid)</h3>
// // //             <ul className="text-gray-700 space-y-2 list-disc list-inside">
// // //               <li><strong>Limit:</strong> Unlimited queries</li>
// // //               <li><strong>Requirement:</strong> Share credit card info and subscribe to plan</li>
// // //               <li><strong>Access:</strong> Full usage of Betsy without restrictions</li>
// // //             </ul>
// // //           </div>
// // //         </div>
// // //       </div>

// // //       <Footer />
// // //     </div>
// // //   );
// // // }

// // // export default LoginSubscription;









// // import React from 'react';
// // import Footer from '../components/Footer';
// // import Header from '../components/Header';

// // function LoginSubscription() {
// //   return (
// //     <div className="min-h-screen flex flex-col">
// //       <Header />

// //       <div className="flex-1 bg-gray-100 mt-[8rem] py-10 px-4">
// //         <h2 className="text-2xl font-bold text-center mb-8">Subscription Plans</h2>

// //         <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
// //           {/* Free Plan Card */}
// //           <div className="bg-white rounded-xl shadow-md border p-6">
// //             <h3 className="text-xl font-semibold text-gray-800 mb-4">Registered User (Free)</h3>
// //             <ul className="text-gray-700 space-y-2 list-disc list-inside">
// //               <li>✅ <strong>Queries Limit:</strong> 20 queries per month</li>
// //               <li>📧 <strong>Login Method:</strong> Email-based login </li>
// //               <li>❌ <strong>Access Scope:</strong> Only public Utah data with AI Betsy limited queries</li>
// //               <li>⏱ <strong>Session Expiry:</strong> 8 hours timeout per session</li>
// //               <li>🔁 <strong>Query History:</strong> Limited to current session only</li>
// //               <li>🔔 <strong>Upgrade Prompt:</strong> Prompt appears after 20 queries</li>
// //             </ul>
// //             <div className="mt-6 text-center">
// //               <button className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md">
// //                 Upgrade to Premium
// //               </button>
// //             </div>
// //           </div>

// //           {/* Premium Plan Card */}
// //           <div className="bg-white rounded-xl shadow-md border p-6">
// //             <h3 className="text-xl font-semibold text-gray-800 mb-4">Premium User (Paid)</h3>
// //             <ul className="text-gray-700 space-y-2 list-disc list-inside">
// //               <li>♾️ <strong>Queries Limit:</strong> Unlimited queries</li>
// //               <li>🔒 <strong>Login Method:</strong> Secure login via email</li>
// //               <li>🌐 <strong>Access Scope:</strong> Full access to all Utah datasets + AI Betsy unlimited queries</li>
// //               <li>⏱ <strong>Session Expiry:</strong> 24 hours (auto-save history)</li>
// //               <li>🕓 <strong>Query History:</strong> Full query history saved</li>
// //             </ul>
// //             <div className="mt-6 text-center">
// //               <button className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-md">
// //                 Subscribe Now
// //               </button>
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       <Footer />
// //     </div>
// //   );
// // }

// // export default LoginSubscription;




// import React, { useEffect, useState } from 'react';
// import Footer from '../components/Footer';
// import Header from '../components/Header';

// function LoginSubscription() {
//   const [accountType, setAccountType] = useState(null);

//   useEffect(() => {
//     const type = localStorage.getItem('account_type');
//     if (type) {
//       setAccountType(type);
//     }
//   }, []);

//   return (
//     <div className="min-h-screen flex flex-col">
//       <Header />

//       <div className="flex-1 bg-gray-100 py-10 px-4">
//         {/* Current Plan Display */}
//         {accountType && (
//           <div className="text-center mb-6">
//             <span className="inline-block bg-blue-100 text-blue-800 font-semibold px-4 py-2 rounded-full">
//               Current Plan: {accountType}
//             </span>
//           </div>
//         )}

//         <h2 className="text-2xl font-bold text-center mb-8">Subscription Plans</h2>

//         <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
//           {/* Free Plan Card */}
//           <div className="bg-white rounded-xl shadow-md border p-6">
//             <h3 className="text-xl font-semibold text-gray-800 mb-4">Registered User (Free)</h3>
//             <ul className="text-gray-700 space-y-2 list-disc list-inside">
//               <li>✅ <strong>Queries Limit:</strong> 20 queries per month</li>
//               <li>📧 <strong>Login Method:</strong> Email-based login (credentials sent via email)</li>
//               <li>❌ <strong>Access Scope:</strong> Only public Utah data with AI Betsy limited queries</li>
//               <li>⏱ <strong>Session Expiry:</strong> 8 hours timeout per session</li>
//               <li>🔁 <strong>Query History:</strong> Limited to current session only</li>
//               <li>🔔 <strong>Upgrade Prompt:</strong> Prompt appears after 20 queries</li>
//             </ul>
//             <div className="mt-6 text-center">
//               <button className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md">
//                 Upgrade to Premium
//               </button>
//             </div>
//           </div>

//           {/* Premium Plan Card */}
//           <div className="bg-white rounded-xl shadow-md border p-6">
//             <h3 className="text-xl font-semibold text-gray-800 mb-4">Premium User (Paid)</h3>
//             <ul className="text-gray-700 space-y-2 list-disc list-inside">
//               <li>♾️ <strong>Queries Limit:</strong> Unlimited queries</li>
//               <li>🔒 <strong>Login Method:</strong> Secure login via email</li>
//               <li>🌐 <strong>Access Scope:</strong> Full access to all Utah datasets + AI Betsy unlimited queries</li>
//               <li>⏱ <strong>Session Expiry:</strong> 24 hours (auto-save history)</li>
//               <li>🕓 <strong>Query History:</strong> Full query history saved</li>
//             </ul>
//             <div className="mt-6 text-center">
//               <button className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-md">
//                 Subscribe Now
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       <Footer />
//     </div>
//   );
// }

// export default LoginSubscription;











import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';

function LoginSubscription() {
  const [accountType, setAccountType] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        const user = JSON.parse(storedUser);
        if (user?.account_type) {
          setAccountType(user.account_type);
        }
      } catch (error) {
        console.error('Error parsing user from localStorage:', error);
      }
    }
  }, []);

  return (
    <div className="min-h-screen flex  flex-col">
      <Header />

      <div className="flex-1 bg-gray-100  py-10 px-4">
        {/* Current Plan Display */}
       <div className='mt-[8rem]'>

        <h2 className="text-2xl font-bold text-center mb-8">Subscription Plans</h2>
         {accountType && (
          <div className="text-center mb-6">
            <span className="inline-block bg-blue-100 text-blue-800 font-semibold px-4 py-2 rounded-full">
              Current Plan: {accountType}
            </span>
          </div>
        )}

        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Free Plan Card */}
          <div className="bg-white rounded-xl shadow-md border hover:scale-50 p-6">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">Registered User (Free)</h3>
            <ul className="text-gray-700 space-y-2 list-disc list-inside">
              <li>✅ <strong>Queries Limit:</strong> 20 queries per month</li>
              <li>📧 <strong>Login Method:</strong> Email-based login </li>
              <li>❌ <strong>Access Scope:</strong> Only public Utah data with AI Betsy limited queries</li>
              {/* <li>⏱ <strong>Session Expiry:</strong> 8 hours timeout per session</li> */}
              <li>🔁 <strong>Query History:</strong> Limited to current session only</li>
              {/* <li>🔔 <strong>Upgrade Prompt:</strong> Prompt appears after 20 queries</li> */}
            </ul>
            <div className="mt-6 text-center">
              <button className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md">
                Upgrade to Pro
              </button>
            </div>
          </div>

          {/* Premium Plan Card */}
          <div className="bg-white rounded-xl shadow-md border p-6">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">Pro User (Paid)</h3>
            <ul className="text-gray-700 space-y-2 list-disc list-inside">
              <li>♾️ <strong>Queries Limit:</strong> Unlimited queries</li>
              <li>🔒 <strong>Login Method:</strong> Secure login via email</li>
              <li>🌐 <strong>Access Scope:</strong> Full access to all Utah datasets + AI Betsy unlimited queries</li>
              {/* <li>⏱ <strong>Session Expiry:</strong> 24 hours (auto-save history)</li> */}
              <li>🕓 <strong>Query History:</strong> Full query history saved</li>
            </ul>
            <div className="mt-6 text-center">
              <button className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-md">
                Upgrade Now
              </button>
            </div>
          </div>
        </div>
      </div>
      </div>

      <Footer />
    </div>
  );
}

export default LoginSubscription;
